import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { PermissionGuard } from "@/components/shared/guards/permission-guard";
import { ModelDetailPage } from "@/features/projects";
import {
  MODEL_TAB_VALUES,
  SCHEMA_COLUMN_GROUP_VALUES,
} from "@/features/projects/shared/types";

const modelSearchSchema = z.object({
  tab: z.enum(MODEL_TAB_VALUES).catch("schema"),
  columnGroup: z.enum(SCHEMA_COLUMN_GROUP_VALUES).catch("inputs"),
  q: z.string().catch(""),
  version: z.string().catch("v1"),
});

export const Route = createFileRoute("/projects/$projectId/models/$modelId")({
  validateSearch: modelSearchSchema,
  component: () => (
    <PermissionGuard module="projects">
      <ModelDetailPage />
    </PermissionGuard>
  ),
});
